export const addVLUserInfo = (user: string) => {
  dataLayer.push({
    event: 'vlEvent',
    vl_label: 'VL-Login',
    vl_userID: user, // Required
  });
};
